export default {
  en: {
    ClientEditScene: {
      title: 'Edit client',
    },
  },
};
